export const API_URL = (): string => {
  // Prefer env; fall back to dev backend instead of localhost
  return (
    import.meta.env.VITE_APP_API_URL_PROXY ??
    "https://dev.services.siplifleet.it"
  );
};

export const ENV = {
  isDevelopment: import.meta.env.MODE === "development",
  isProduction: import.meta.env.MODE === "production",
  isPreprod: import.meta.env.MODE === "pre-prod",
  apiUrl: API_URL(),
} as const;
